import styled from 'styled-components';

export const NoHoldingsWrapper = styled.section`
  text-align: center;
  > p {
    padding-top: 48px;
    max-width: 250px;
    margin: 0 auto 32px;
  }
`;
